import { initMainMenu } from "./menu";

declare const jQuery: any;
const $ = jQuery;

export function initMainMenuPopup(): void
{
	initMainMenu($(".main-menu-popup-content"));
}
